import { createAction, props } from '@ngrx/store';

export const updateUserFlag = createAction(
  '[Common] Update User Flag',
  props<{ userFlag: string }>()
);

export const CommonActions = {
  updateUserFlag,
};

